var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"directions-map-wrap"},[_c('div',{staticClass:"map-canvas",attrs:{"id":"directions-map","aria-hidden":"true"}}),_c('MapGps',{attrs:{"map":_vm.map,"directionsGps":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }